var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallOutgoing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.953,
    height: 19.953,
    viewBox: "0 0 19.953 19.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80.089 -0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.548,19.96a3,3,0,0,1-.8-.11c-1.62-.45-4.42-1.854-8.555-5.99S80.65,6.927,80.2,5.307a3.015,3.015,0,0,1,.771-2.935L83.189.153a.5.5,0,0,1,.707,0l4,4a.5.5,0,0,1,.062.631L86.186,7.443l6.42,6.42,2.659-1.772a.5.5,0,0,1,.631.062l4,4a.5.5,0,0,1,0,.707l-2.22,2.22A3.011,3.011,0,0,1,95.548,19.96ZM83.542,1.214,81.677,3.079a2.013,2.013,0,0,0-.514,1.96c.418,1.505,1.752,4.134,5.733,8.114s6.611,5.316,8.115,5.734a2.015,2.015,0,0,0,1.958-.514l1.866-1.866L95.479,13.15,92.82,14.923a.5.5,0,0,1-.631-.063l-7-7a.5.5,0,0,1-.063-.631L86.9,4.57Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.146,7.854a.5.5,0,0,0,.708,0L98,2.707V6.5a.5.5,0,0,0,1,0v-5a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0,0,1h3.793L92.146,7.146A.5.5,0,0,0,92.146,7.854Z",
    transform: "translate(-80.089 -0.007)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOutgoing);
export default __webpack_public_path__ + "static/media/Call_Outgoing.048494bbe4edc242d3e7fd1985623e62.svg";
export { ForwardRef as ReactComponent };